<app-admin-boilerplate>
    <h1>Event Organisers</h1>
    @if (userOrganisers$ | async; as userOrganisers){
        @for (organiser of userOrganisers; track $index){
            <div class="card cursor-pointer" [routerLink]="['/admin','organisers',organiser.organiserID]">
                <div class="flex">
                    <div class="flex flex-col w-full">
                        <div class="text-lg font-semibold my-auto">
                            {{ organiser.name }}
                        </div>
                    </div>
                    <div>
                        @if (organiser.image){
                            <img [src]="organiser.image.url" class="max-h-12"/>
                        }
                    </div>
                </div>
            </div>
        }
    }
</app-admin-boilerplate>